import React, { Component } from 'react';
import { connect } from 'react-redux';
import './serviceDetail.scss';
import { Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import BackIcon from "../../../images/arrow.png";
import Lamps from "../../../images/service/Lamps-and-lights-fitting.jpg";
import Power from "../../../images/service/Power-outlet and-socket-repair.jpg";
import Inverter from "../../../images/service/Inverter-and-Stabilizer.jpg";
import Appliance from "../../../images/service/Appliance.jpg";
import WaterMotor from "../../../images/service/Water-motor.jpg";
import ElectricalWiring from "../../../images/service/Electrical-wiring.jpg";
import MCB from "../../../images/service/MCB-and-Fuse.jpg";
import { Link } from "react-router-dom";
import Header from "../../../layout/DefaultLayout/Header";
class ServiceDetail extends Component {

   constructor(props) {
      super(props);
      this.state = {
         formError: {},
         formSubmit: false,
         user: {},
         userNumber: '****7890',
         isSuccess: true,
      }
   }


   render() {
      const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
      return (
         <div>
            <Header></Header>
            <div className="header-container">
               <Link to="/">
                  <img src={BackIcon} className="arrow-icon" alt="" />
               </Link>
               <div className="main-heading-txt">Electrician</div>
            </div>
            <div className='service-container'>
               <div className="containt-container">
                  {/* <div className="heading-txt">Television</div> */}
                  <div className="row">
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={Lamps} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Lamps and lights fitting</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={Power} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Power outlet and socket repair</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={Inverter} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Inverter and Stabilizer</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="row">
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={Appliance} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Appliance</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={WaterMotor} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Water motor</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={ElectricalWiring} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">Electrical Wiring</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="row">
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">
                           <div><img src={MCB} className="service-avatar-image" alt="" /></div>
                           <div className="service-txt-container">
                              <div className="image-service-text">MCB & Fuse</div>
                              <div className="service-time">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                              <Link to="/service/1/2">
                                 <button className="add-btn">BID REQUEST</button>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">

                     </div>
                     <div className="col-sm-12 col-md-4 col-xs-12">
                        <div className="service-box-container">

                        </div>
                     </div>
                  </div>

               </div>

            </div>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { user } = state.authentication;
   return {
      user,
   }
}
export default connect(mapStateToProps)(ServiceDetail);